import React from 'react';
import { useDisclosure } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { OptionsMenu } from 'components/OptionsMenu';
import { ItemMenuButton } from '../ItemMenuButton';
import { OptionsMenuItem } from 'components/OptionsMenu/OptionsMenuItem';

export const ItemMenuError = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <OptionsMenu
      button={<ItemMenuButton onClick={onOpen} />}
      isOpen={isOpen}
      onClose={onClose}
    >
      <OptionsMenuItem>
        {t`Could not load the options for this item`}
      </OptionsMenuItem>
    </OptionsMenu>
  );
};
